import * as R from 'ramda';
import { addDays, format, isValid, parseISO, startOfDay } from 'date-fns';
import palette from 'library/theme/palette';

const OPEN_ENDED_DATE_THRESHOLD = parseISO('2999-12-31T00:00:00');

const isOpenEndedDate = parsedDate => R.gte(parsedDate, OPEN_ENDED_DATE_THRESHOLD);

const defaultEndDateDisplay = {
  chipBackgroundColor: null,
  label: '',
  showChip: false,
  textColor: palette.text.primary,
  tooltip: '',
};

const openEndedEndDateDisplay = {
  chipBackgroundColor: null,
  label: '--',
  showChip: false,
  textColor: palette.text.primary,
  tooltip: '',
};

export const endDateDisplayUtils = endDate => {
  const parsedDate = parseISO(endDate);
  if (!endDate || !isValid(parsedDate)) {
    return defaultEndDateDisplay;
  }

  if (isOpenEndedDate(parsedDate)) {
    return openEndedEndDateDisplay;
  }

  const today = startOfDay(new Date());
  const plus60Days = addDays(today, 60);
  const formattedDate = format(parsedDate, 'MM/dd/yyyy');
  const startOfEndDate = startOfDay(parsedDate);

  if (R.gt(startOfEndDate, plus60Days)) {
    return {
      chipBackgroundColor: palette._next.statusChip.primary.background,
      label: formattedDate,
      showChip: true,
      textColor: palette._next.statusChip.primary.dark,
      tooltip: 'More than 60 days until expiration',
    };
  }

  if (R.gte(startOfEndDate, today) && R.lte(startOfEndDate, plus60Days)) {
    return {
      chipBackgroundColor: palette._next.statusChip.warning.background,
      label: formattedDate,
      showChip: true,
      textColor: palette._next.statusChip.warning.dark,
      tooltip: 'Expiring within the next 60 days',
    };
  }

  if (R.lt(startOfEndDate, today)) {
    return {
      chipBackgroundColor: palette._next.statusChip.error.background,
      label: formattedDate,
      showChip: true,
      textColor: palette._next.statusChip.error.main,
      tooltip: 'Record is expired',
    };
  }

  return defaultEndDateDisplay;
};

export default endDateDisplayUtils;
